import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { productionService } from "../services/production";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

const ProductionDrafts = () => {
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchDrafts();
  }, []);

  const fetchDrafts = async () => {
    try {
      setLoading(true);
      const data = await productionService.getProductionOrderDrafts();
      setDrafts(Array.isArray(data) ? data : []);
    } catch (err) {
      // Em caso de erro, definir drafts como vazio (não mostrar erro)
      console.error("Erro ao buscar rascunhos:", err);
      setDrafts([]);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadDraft = (id) => {
    navigate(`/new-production?draft_id=${id}`);
  };

  const handleDeleteDraft = async (id) => {
    if (window.confirm("Tem a certeza que pretende eliminar este rascunho?")) {
      try {
        await productionService.deleteProductionOrderDraft(id);
        toast.success("Rascunho excluído com sucesso!");
        fetchDrafts(); // Atualiza a lista
      } catch (err) {
        toast.error(err.message || "Erro ao excluir rascunho.");
      }
    }
  };

  if (loading) {
    return <div className="text-center p-8">A carregar rascunhos...</div>;
  }

  return (
    <div className="container-fluid p-4 sm:p-6 lg:p-8">
      {/* Header responsivo */}
      <div className="mb-6">
        <h1 className="text-2xl mb-4">Rascunhos de Ordens de Produção</h1>
        <div className="flex justify-end">
          <button
            onClick={() => navigate("/new-production")}
            className="w-full sm:w-auto px-4 py-2 bg-neutral-900 text-white rounded-lg hover:bg-neutral-800"
          >
            <FontAwesomeIcon icon={faPlus} className="mr-2" />
            Nova Ordem
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-neutral-50">
              <tr>
                <th className="px-4 py-3 text-left">Nome do Rascunho</th>
                <th className="px-4 py-3 text-left">Criado em</th>
                <th className="px-4 py-3 text-left">Última Modificação</th>
                <th className="px-4 py-3 text-right">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-neutral-100">
              {drafts.length > 0 ? (
                drafts.map((draft) => (
                  <tr key={draft.id}>
                    <td className="px-4 py-4">{draft.draft_name}</td>
                    <td className="px-4 py-4">
                      {new Date(draft.created_at).toLocaleString()}
                    </td>
                    <td className="px-4 py-4">
                      {new Date(draft.updated_at).toLocaleString()}
                    </td>
                    <td className="px-4 py-4 text-right">
                      <button
                        onClick={() => handleLoadDraft(draft.id)}
                        className="text-blue-600 hover:text-blue-800 mr-4"
                        title="Carregar Rascunho"
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        onClick={() => handleDeleteDraft(draft.id)}
                        className="text-red-600 hover:text-red-800"
                        title="Excluir Rascunho"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="px-4 py-8">
                    <div className="text-center">
                      <div className="text-neutral-500 mb-6">
                        <p className="text-lg mb-2">Nenhum rascunho encontrado</p>
                        <p className="text-sm">Crie uma nova ordem para começar</p>
                      </div>
                      <button
                        onClick={() => navigate("/new-production")}
                        className="px-6 py-2 bg-neutral-900 text-white rounded-lg hover:bg-neutral-800"
                      >
                        <FontAwesomeIcon icon={faPlus} className="mr-2" />
                        Nova Ordem
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductionDrafts;
